import JSONApiClient from '../jsonapi-service';
import { authService } from '../auth-service';
import AxiosService from '../axios-service';

import { CAMPAIGN_OWNER, CAMPAIGN_ADMIN, TEAM_MEMBER } from '../../utils/static-configuration';

export function createCampaignPermission(campaignPermissionData) {
  const client = JSONApiClient();

  const campaignPermission = client.create('campaignPermission');

  campaignPermission.set('campaign', { type: 'campaigns', id: campaignPermissionData.campaignId });
  campaignPermission.set('user', { type: 'users', id: campaignPermissionData.userId });
  campaignPermission.set('email', campaignPermissionData.email);
  campaignPermission.set('role', campaignPermissionData.role);
  campaignPermission.set('organisation', { type: 'organisations', id: campaignPermissionData.organisationId });

  return campaignPermission.sync()
    .then(response => response);
}

export function getCampaignPermission(permissionId) {
  const client = JSONApiClient();

  return client.get('campaignPermission', permissionId, {})
    .then(response => response);
}

export function deleteCampaignPermission(campaignPermission) {
  return campaignPermission.delete()
    .then(response => response);
}

export function updatePermissionStatus(permissionId, status) {
  const client = JSONApiClient();

  return client.get('campaignPermission', permissionId, {})
    .then(campaignPermission => {
      campaignPermission.set('status', status);
      return campaignPermission.sync();
    });
}

function makeTrackedAssetsQuery(userId) {
  const query = `
  query CampaignPermissionTrackedAssets {
    campaignPermission(user: "${userId}") {
      id
      role
      campaign {
        id
        name
        currency
        trackedAssets {
          id
          assetId
          assetURL
          platform
          assetType
          createdSource
          createdBy
          createdDate
          user {
            id
          }
          campaign {
            id
            name
          }
          discussion {
            id
            name
          }
        }
        discussions {
          id
          name
          trackedAssets {
            id
            assetId
            assetURL
            platform
            assetType
            createdSource
            createdBy
            createdDate
            user {
              id
            }
            campaign {
              id
              name
            }
            discussion {
              id
              name
            }
          }
        }
      }
    }
  }
  `;
  return query;
}

export function getCampaignPermissionTrackedAssets(userId) {
  const axiosService = new AxiosService(process.env.REACT_APP_API_BASE_URL, 10000, { Authorization: `Bearer ${authService.getToken()}` });

  const query = makeTrackedAssetsQuery(userId);

  return axiosService.post('', {
    query,
    variables: null,
    operationName: null,
  })
    .then(response => {
      const campaignPermissions = response.data.data.campaignPermission;
      const filteredCampaignPermissions = [];
      campaignPermissions.forEach(campaignPermission => {
        const role = campaignPermission.role;
        if (role === CAMPAIGN_OWNER || role === CAMPAIGN_ADMIN || role === TEAM_MEMBER) {
          filteredCampaignPermissions.push(campaignPermission);
        }
      });
      return filteredCampaignPermissions;
    });
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-functions/campaign-permissions.js
 **/